export default __webpack_public_path__ + "static/media/idd3.1dee74fe.png";